import React from 'react';
import { Card, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faHome } from '@fortawesome/free-solid-svg-icons';

import { useMsal } from '@azure/msal-react';
import { AuthenticatedTemplate } from '@azure/msal-react';

import { IdTokenData } from '../components-csvc-one/DataDisplay.jsx';

function decodeJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(c => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

const Alfa = () => {
  const { instance } = useMsal();
  let activeAccount;

  if (instance) {
    activeAccount = instance.getActiveAccount();

    // console.log(JSON.stringify(activeAccount));
    // console.dir(activeAccount);
    // console.dirxml(activeAccount);
    /*
    return (
      <>
        <p>activeAccount.IdTokenData: {activeAccount.access}</p>
        <p>activeAccount.tenantId: {activeAccount.tenantId}</p>
      </>
    )
    */


  
    const token = activeAccount.idToken;
    const payload = decodeJwt(token);
    console.log(payload);  // Output: { exp: 10012016, name: "john doe", scope: ["admin"] }

    return (
      <>
        <AuthenticatedTemplate>
          {activeAccount ? ( <Container>
                <IdTokenData idTokenClaims={activeAccount.idTokenClaims} />
                <p>
                  INSERISCO DI SEGUITO MIEI ESPERIMENTI DI LETTURA TOKEN DA
                  activeAccount
                </p>
                <p>idToken: {activeAccount.idToken}</p>
                <p>payload.sub: {payload.sub}</p>
                <p>payload.jobTitle: {payload.jobTitle}</p>
                <p>payload.given_name: {payload.given_name}</p>
                <p>payload.family_name: {payload.family_name}</p>
                <p>payload.emails: {payload.emails.map ((x) =>{ return (`${x}, `)})}</p>
                </Container> 
              )
              :
              null
          }
        </AuthenticatedTemplate>
      </>
    )
  }
  else {
    return (
      <Card className="text-center">
        <Card.Body className="p-5">
          <div className="display-1 text-300 fs-error">Alfa</div>
          <p className="lead mt-4 text-800 font-sans-serif fw-semibold">
            La pagina che hai richiesto è ancora in fase di redazione.
          </p>
          <hr />
          <Link className="btn btn-primary btn-sm mt-3" to="/">
            <FontAwesomeIcon icon={faHome} className="me-2" />
            Vai alla Homepage
          </Link>
        </Card.Body>
      </Card>
    );
  }
};

export default Alfa;
